/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import Slider, { Settings } from 'react-slick';

type SliderProps = {
  className?: string;
  children: any;
  settings?: Settings;
};

export default class SliderWrapper extends React.Component<SliderProps> {
  private slider: Slider | null = null;

  settings: Settings = {
    dots: true,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: true,
    lazyLoad: 'ondemand',
    appendDots: (dots: React.ReactNode) => {
      return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          <div className="d-flex justify-content-center slick-dots mt-5">
            <button
              type="button"
              className="btn btn-reset slick-prev"
              aria-label="Prevous slider"
              onClick={() => this.slider && this.slider.slickPrev()}
            />
            <ul className="p-0 mb-0 d-flex align-items-center">{dots}</ul>
            <button
              type="button"
              className="btn btn-reset slick-next"
              aria-label="Next slider"
              onClick={() => this.slider && this.slider.slickNext()}
            />
          </div>
        </>
      );
    },
    ...this.props.settings
  };

  render() {
    return (
      <Slider
        {...this.settings}
        ref={(c) => {
          this.slider = c;
        }}
        className={this.props.className || ''}>
        {this.props.children}
      </Slider>
    );
  }
}
